module.exports = __webpack_public_path__ + "img/img8.b3e20d17.png";